import { render, staticRenderFns } from "./SchoolRankings.vue?vue&type=template&id=23651b8d"
import script from "./SchoolRankings.vue?vue&type=script&lang=js"
export * from "./SchoolRankings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports